import { ApiError } from '@/lib/api-client';

export type UserArrangementExistsError = {
  code: 'user_arrangement_exists';
  user_arrangement_id: string;
  detail: string;
};

export function isUserArrangementExistsError(
  error: unknown,
): error is ApiError & { body: UserArrangementExistsError } {
  if (!(error instanceof ApiError)) return false;
  if (error.status !== 409) return false;
  const body = error.body;
  if (typeof body !== 'object' || body === null) return false;
  const candidate = body as Record<string, unknown>;
  return (
    candidate.code === 'user_arrangement_exists' &&
    typeof candidate.user_arrangement_id === 'string'
  );
}
